import React from 'react';
import SEO from '../../common/SEO';
import Layout from '../../common/Layout';
import BannerFour from '../../components/banner/BannerFour';
import HomeFourServices from '../../components/home-four/HomeFourServices';
import HomeFourAbout from '../../components/home-four/HomeFourAbout';
import VideoSectionOne from '../../components/video-section/VideoSectionOne';
import CallToActionTwo from '../../components/cta/CallToActionTwo';
import HomeFourBlog from '../../components/home-four/HomeFourBlog';

const HomeFour = () => {
    return (
        <>
            <SEO title="Green Cap High School — Quality, Value, Wisdom" />

            <Layout>

                <BannerFour />

                <HomeFourServices />

                <HomeFourAbout />

                <VideoSectionOne />

                <CallToActionTwo />

                <HomeFourBlog />

            </Layout>
        </>
    )
}

export default HomeFour;